<header role="banner">
  <!--
    `has-ditta` porta nella CSS un'informazione che altrimenti solo il
    template conosce: con una ditta selezionata compare un pulsante in più,
    la riga di controlli chiede ~75px di larghezza aggiuntivi e smette di
    stare accanto al blocco logo/azioni molto prima. Le soglie responsive di
    quella riga dipendono quindi da questo stato, non dalla sola larghezza.
  -->
  <div class="main-container" [class.has-ditta]="!!dittaSelected">

    <div class="left-container">

      <div class="first-raw-mobile">
        @if (!!imgLogo) {
          <div class="logo-container">
            <img [ngSrc]="imgLogo" alt="Logo" width="184" height="54" priority>
          </div>
        }
        @if (userService.currentUser(); as user) {
          @if (userService.currentUserPermission() != null && userService.currentUserPermission() === 1) {
            <span class="caption-extra-small mobile"><strong>{{ user!.commInfo.commercialista }}</strong></span>
          } @else if (userService.currentUserPermission() != null && userService.currentUserPermission() === 0) {
            <button type="button" class="action-red-button label-small" (click)="goHome()"
                    aria-label="Apri home studio">
              <img ngSrc="/icon/home.png" alt="" width="18" height="18" aria-hidden="true">
              <span class="btn-label">STUDIO</span>
            </button>

            <button type="button" class="action-waterGreen-button label-small" (click)="goAssistenza()"
                    aria-label="Apri pagina assistenza">
              <img ngSrc="/icon/assistenza.png" alt="" width="18" height="18" aria-hidden="true">
              <span class="btn-label">ASSISTENZA</span>
            </button>
          }
        }
        <div class="button-logout-container">
          <button type="button" class="action-logout-button mobile" (click)="logout()" aria-label="Esci">
            <img ngSrc="/icon/logout.svg" alt="" width="18" height="18" aria-hidden="true">
          </button>
        </div>
      </div>


      <div class="info-container">

        <div class="action-container">

          <div class="second-raw-mobile">
            <!-- Pulsante hamburger visibile solo su tablet/mobile.
                 Gestione accessibilità:
                 - aria-label descrive l'azione corrente (apertura/chiusura)
                 - aria-expanded comunica lo stato del menu laterale
                 - aria-controls collega il pulsante all'aside #sidebar -->
            <button
              type="button"
              class="hamburger-btn caption"
              (click)="toggleLeftMenu()"
              [attr.aria-label]="isLeftMenuOpen ? 'Chiudi menu' : 'Apri menu'"
              [attr.aria-expanded]="isLeftMenuOpen ? 'true' : 'false'"
              aria-controls="sidebar">
              <img
                class="hamburger-btn-image"
                [ngSrc]="isLeftMenuOpen ? '/icon/close.png' : '/icon/hamburger-menu.svg'"
                alt=""
                width="16"
                height="16"/>
            </button>
          </div>

          @if (userService.currentUserPermission() != null && userService.currentUserPermission() === 0) {
            <!-- TODO quando presenti si dovrà aggiungere la lista delle ditte seguite dal commercialista che ha fatto la login -->
            <app-input-dropdown
              [placeholder]="'Seleziona Ditta . . .'"
              [listaValori]="['Ditta 1', 'Ditta 2', 'Ditta 3']"
              [defaultValue]="dittaSelected"
              (valoreSelectedEmit)="onDittaSelected($event)"
              (expandedChange)="onDropdownExpandedChange($event)"
            ></app-input-dropdown>

            @if (!!dittaSelected) {
              <button
                type="button"
                class="action-blue-button label-small"
                (click)="goHome(true)"
                aria-label="Apri home ditta"
              >
                <img ngSrc="/icon/home.png" alt="" width="18" height="18" aria-hidden="true">
                <span class="btn-label">DITTA</span>
              </button>
            }

            <button
              type="button"
              class="action-red-button label-small"
              (click)="goHome()"
              aria-label="Apri home studio"
            >
              <img ngSrc="/icon/home.png" alt="" width="18" height="18" aria-hidden="true">
              <span class="btn-label">STUDIO</span>
            </button>

            <button
              type="button"
              class="action-waterGreen-button label-small"
              (click)="goAssistenza()"
              aria-label="Apri pagina assistenza"
            >
              <img ngSrc="/icon/assistenza.png" alt="" width="18" height="18" aria-hidden="true">
              <span class="btn-label">ASSISTENZA</span>
            </button>
          }

          <button
            type="button"
            class="action-logout-button"
            (click)="logout()"
            aria-label="Esci dalla procedura"
          >
            <img ngSrc="/icon/logout.svg" alt="" width="18" height="18" aria-hidden="true">
          </button>

        </div>

        <div class="codiceDestinatario-container">
            <span class="caption grey-text-color">
              Codice Destinatario:
              <strong class="caption"> VUS5DID</strong>
            </span>
        </div>
      </div>
    </div>

    <!-- logo principale a destra e pulsante pannello destro su mobile/tablet -->
    <div class="right-container">
      @if (!!imgLogo && !config?.showCompanyName) {
        <div class="logo-container">
          <img [ngSrc]="imgLogo" alt="Logo" width="184" height="54" priority>
        </div>
      } @else {
        <div class="logo-container" style="display: flex; align-items: center;">
          <span class="h3-title">{{ config?.companyName || 'Azienda di Test' }}</span>
        </div>
      }
    </div>
  </div>
</header>
